import { useState, useEffect } from "react";

import { Container, Grid, Card } from "@material-ui/core";

import Api from "lib/api/httpRequestHelper";
import useStructureQueries from "hooks/useStructureQueries";
import NotFound from "../../../components/Texts/NotFound";
import LoadingData from "components/Loading/LoadingData";
import HeaderClientes from "components/_refactor/headers/clients";
import FilterCard from "components/_refactor/filter-card";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import DateField from "components/_refactor/fields/date";
import InputText from "components/_refactor/text/input";
import TableHistoricPrices from "./table/TableHistoricoDeAlteracaoDePrecos";
import { IsMobile900, IsMobile } from "utils/is-mobile";

export default function HistoricPrices() {
  const { getProductLines } = useStructureQueries();

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXS = isMobile ? 12 : isMobile900 ? 6 : 4;

  const [resultados, setResultados] = useState(null);
  const [searching, setSearching] = useState(false);
  const [dataSelecionada, setDataSelecionada] = useState();
  const [productCode, setProductCode] = useState("");
  const [product, setProduct] = useState("");
  const [productsLineData, setProductsLineData] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [loadingProducstLine, setLoadingProductsLine] = useState(false);

  const handleSubmit = async () => {
    setCancelLoading(false);
    setResultados(null);
    setSearching(true);

    await Api.get(
      "products-price-historic",
      "product",
      "?dataAnterior=" +
        dataSelecionada +
        "&linhaProduto=" +
        product.IdProdutoLinha +
        "&codigoProduto=" +
        productCode,
      true
    )
      .then((value) => {
        if (value.Result?.length > 0) {
          setResultados(value.Result);
        } else {
          setNotFound(true);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setNotFound(true);      })
      .finally(() => setSearching(false));
  };

  const getProductsLine = async () => {
    setLoadingProductsLine(true);
    try {
      const result = await getProductLines();
      const res = result?.data ?? {};
      setProductsLineData(Array.isArray(res) ? res : (res.Linha ?? []));
    } catch (error) {
      console.log("error", error);    } finally {
      setLoadingProductsLine(false);
    }
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setSearching(true);
    setDataSelecionada(null);
    setProductCode("");
    setProduct("");
    setSearching(false);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setResultados(null);
  };

  useEffect(() => {
    if (product === "" && productCode === "") {
      setClearFilters(false);
    }
  }, [productCode, product, dataSelecionada, clearFilters]);

  useEffect(() => {
    getProductsLine();
  }, []);

  return (
    <>
      <HeaderClientes
        section="Histórico de Alteração de Preços"
        subsection="Produtos"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={() => handleSubmit()}
          disabled={searching || loadingProducstLine}
          searching={searching}
          handleClearFilters={handleClearFilters}
        >
          <Grid item xs={itemXS}>
            <DateField
              onChange={setDataSelecionada}
              value={dataSelecionada}
              disabled={searching || loadingProducstLine}
              label="Data de Comparação"
            />
          </Grid>
          <Grid item xs={itemXS}>
            <AutoCompleteField
              label="Linha de Produto"
              options={productsLineData}
              loading={clearFilters}
              onChange={setProduct}
              value={product}
              disabled={searching || loadingProducstLine}
              optionLabelKey="Descricao"
              optionIdKey="IdProdutoLinha"
            />
          </Grid>
          <Grid
            item
            xs={itemXS}
            style={{
              marginTop: isMobile || isMobile900 ? "-1.5rem" : 0,
            }}
          >
            <InputText
              label="Código do Produto"
              value={productCode}
              onChange={(e) => {
                setProductCode(e.target.value.slice(0, 9));
              }}
              disabled={searching || loadingProducstLine}
              placeholder="Digite o código do produto"
            />
          </Grid>
        </FilterCard>

        <Grid item xs={12}>
          <LoadingData
            searching={searching}
            onClick={() => handleStopSearching()}
            label="Buscando dados..."
          />
        </Grid>

        <Grid item xs={12}>
          {!searching && resultados && !cancelLoading && (
            <TableHistoricPrices dataTable={resultados} />
          )}
        </Grid>

        {!searching && notFound && !cancelLoading && (
          <Card>
            <NotFound
              title="Não há histórico de alteração de preço no período."
              subtitle=""
            />
          </Card>
        )}
      </Container>
    </>
  );
}
